// extracted by mini-css-extract-plugin
module.exports = {"modal":"BlockingModal_modal__3VQtQ","description":"BlockingModal_description__HZRqT","button":"BlockingModal_button__19bQ6"};